
class StorageUtil {

    static setItem(store, json) {
        if (json) {
            localStorage.setItem("GE-" + store, json);
        } else {
            StorageUtil.removeItem(store);
        }
    }

    static getItem(store) {
        return localStorage.getItem("GE-" + store);
    }

    static getObject(store) {
        return JSON.parse(StorageUtil.getItem(store));
    }

    static removeItem(store) {
        localStorage.removeItem("GE-" + store);
    }

}

export default StorageUtil;